export const meta = {
  id: 'M13',
  slug: 'ciclo-continuo',
  title: 'Ciclo de acompanhamento contínuo',
  description: 'Entenda como contexto, Mentoria, Acordos, execução, Evidências e progresso se conectam no acompanhamento do mentorado.',
  profile: 'mentor',
  category: 'acompanhamento',
  type: 'flow',
  status: 'published',
  order: 340,
  keywords: ['ciclo', 'acompanhamento', 'mentoria', 'acordos', 'execução', 'evidências', 'progresso'],
  previous: 'M12',
  related: ['M02', 'M08', 'M10', 'M12'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Ciclo de acompanhamento contínuo

O acompanhamento no Personagrama não termina na sessão de Mentoria. A sessão faz parte de um ciclo que conecta reflexão, ação e evolução.

## O ciclo

<Diagram kind="mentoring-cycle" />

<Steps>
  <Step title="Compreender">
    Use a Visão 360 e os demais dados disponíveis para entender o momento do mentorado.
  </Step>
  <Step title="Orientar">
    Conduza a Mentoria com foco nas questões que mais podem gerar desenvolvimento.
  </Step>
  <Step title="Combinar">
    Registre Acordos e próximos passos claros.
  </Step>
  <Step title="Executar">
    O mentorado aplica o que foi combinado em seu contexto real.
  </Step>
  <Step title="Demonstrar">
    Evidências e resultados ajudam a tornar a evolução observável.
  </Step>
  <Step title="Acompanhar">
    Observe progresso, dificuldades e mudanças até a próxima Mentoria.
  </Step>
</Steps>

**COMPREENDER → ORIENTAR → COMBINAR → EXECUTAR → DEMONSTRAR → ACOMPANHAR → NOVA MENTORIA.**

<Callout type="concept">
  O valor do acompanhamento está na continuidade. Cada Mentoria deve dialogar com o que aconteceu antes e preparar a próxima etapa do desenvolvimento.
</Callout>
